/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.contentEditorModule')
.directive('bulbFontColor', bulbFontColor);

function bulbFontColor() {
  return {
    scope: false,
    link: function(scope, elem, attr, ctrl) {
      // Grabs the color selected, and then adds it to the style.
      var selectedFontColor = attr.bulbFontColor;
      $(elem).css('color', selectedFontColor);
      $(elem).addClass('handled-span');
    }
  };
}
